import { ContactsMap } from '@components/contatti/contacts-map';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { PageHead } from '../../components/common/head/page-head';
import { Navbar } from '../../components/common/navbar/navbar';
import styles from './index.module.css';
import { useSiteData } from '../../context/site-data-context';

export default function Contatti() {
  const { serviceCategories, technologyCategories } = useSiteData();
  const intl = useIntl();
  return (
    <>
      <PageHead
        title={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - An IBM company - Contatti',
          description: 'Contatti - Page title'
        })}
        description={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - Contatti',
          description: 'Contatti - Page description'
        })}
      />
      <Navbar
        navCssClasses={classNames(styles.navbarBackground, 'position-fixed')}
        navLinkCssClasses={styles.navItem}
        serviceCategories={serviceCategories}
        technologyCategories={technologyCategories}
      />

      <main role="main" className="mt-5">
        <ContactsMap />
      </main>
    </>
  );
}
